import React from 'react';

export default {
  'arrow-with-bullet': (size, color) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 10"
      width={size}
      height={size}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M5.143.17C2.228.17 0 2.339 0 5.176c0 2.502 2.057 4.671 4.628 4.838 2.4.167 4.629-1.168 5.314-3.337h7.201v3.337L24 5.009 17.143.003V3.34H9.942C9.257 1.505 7.371.17 5.143.17z"
      />
    </svg>
  ),
  clock: (size, color) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      width={size}
      height={size}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M10 0C4.465 0 0 4.465 0 10s4.465 10 10 10 10-4.465 10-10S15.535 0 10 0zm0 2c4.465 0 8 3.535 8 8s-3.535 8-8 8-8-3.535-8-8 3.535-8 8-8zM9 5v5.406l.281.313 3 3 1.438-1.438L11 9.563V5H9z"
      />
    </svg>
  ),
  calendar: (size, color) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      width={size}
      height={size}
    >
      <g>
        <rect
          fill="none"
          id="canvas_background"
          height="402"
          width="582"
          y="-1"
          x="-1"
        />
      </g>
      <g>
        <path
          id="svg_1"
          d="m3,0l0,2l-1,0c-1.1,0 -2,0.9 -2,2l0,14c0,1.1 0.9,2 2,2l14,0c1.1,0 2,-0.9 2,-2l0,-14c0,-1.1 -0.9,-2 -2,-2l-1,0l0,-2l-2,0l0,2l-8,0l0,-2l-2,0zm-1,7l14,0l0,11l-14,0l0,-11z"
          fill={color}
        />
        <rect
          id="svg_2"
          height="3.02822"
          width="3.02822"
          y="8.516"
          x="3.36772"
          fill={color}
        />
        <rect
          id="svg_3"
          height="3.02822"
          width="3.02822"
          y="8.51136"
          x="7.48589"
          fill={color}
        />
        <rect
          id="svg_4"
          height="3.02822"
          width="3.02822"
          y="8.46239"
          x="11.64859"
          fill={color}
        />
        <rect
          id="svg_5"
          height="3.02822"
          width="3.02822"
          y="13.13942"
          x="3.42094"
          fill={color}
        />
        <rect
          id="svg_6"
          height="3.02822"
          width="3.02822"
          y="13.09044"
          x="7.53487"
          fill={color}
        />
      </g>
    </svg>
  ),
  magnify: (size, color) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      width={size}
      height={size}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M20.005 18.626l-1.372 1.371-5.704-5.704A7.959 7.959 0 0 1 8 16a8 8 0 1 1 8-8 7.959 7.959 0 0 1-1.701 4.92l5.706 5.706zM8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2z"
      />
    </svg>
  ),
  passenger: (size, color) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      width={size}
      height={size}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M10 0C7.236 0 5 2.236 5 5c0 2.763 2.236 5 5 5a4.997 4.997 0 0 0 4.999-5c0-2.764-2.236-5-4.999-5zm0 12.5c-7.627 0-10.001 5-10.001 5V20H20v-2.5s-2.373-5-10-5z"
      />
    </svg>
  ),
  checked: (size, color) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 10"
      width={size}
      height={size}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M4.228 9.928L-.003 5.821l1.396-1.448 2.835 2.753L10.597.943l1.394 1.448-7.763 7.537z"
      />
    </svg>
  ),
  'select-triangle': (size, color) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 10 5"
      width={size}
      height={size}
    >
      <path fill={color} fillRule="evenodd" d="M9.991 0L5 4.991.008 0h9.983z" />
    </svg>
  ),
  seat: (size, color) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 33">
      <path
        fill={color}
        fillRule="evenodd"
        d="M30.5 0h-23A2.5 2.5 0 0 0 5 2.5V3H2.5A2.5 2.5 0 0 0-.001 5.5V27A3 3 0 0 0 3 30h2c0 1.657 1.342 3 2.999 3h22A3 3 0 0 0 33 30V2.5A2.5 2.5 0 0 0 30.5 0z"
      />
      <path
        fill="#AAA"
        fillRule="evenodd"
        d="M30.5 0h-23A2.5 2.5 0 0 0 5 2.5V3H2.5A2.5 2.5 0 0 0-.001 5.5V27A3 3 0 0 0 3 30h2c0 1.657 1.342 3 2.999 3h22A3 3 0 0 0 33 30V2.5A2.5 2.5 0 0 0 30.5 0zM28 26.586V6.414l3-3v26.172l-3-3zM6.999 3A1 1 0 0 1 8 2h21.586l-3 3H7.999a1 1 0 0 1-1-1V3zM5.183 28H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h2.183a2.993 2.993 0 0 0 2.816 2H26v19H7.999a2.99 2.99 0 0 0-2.816 2zm1.816 2v-1A1 1 0 0 1 8 28h18.586l3 3H7.999a1 1 0 0 1-1-1z"
      />
    </svg>
  ),
  selectedSeat: () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 33">
      <path
        fill="#DB173F"
        fillRule="evenodd"
        d="M30.5 0h-23A2.5 2.5 0 0 0 5 2.5V3H2.5A2.5 2.5 0 0 0-.001 5.5V27A3 3 0 0 0 3 30h2c0 1.657 1.342 3 2.999 3h22A3 3 0 0 0 33 30V2.5A2.5 2.5 0 0 0 30.5 0z"
      />
      <path
        fill="#83001B"
        fillRule="evenodd"
        d="M30.5 0h-23A2.5 2.5 0 0 0 5 2.5V3H2.5A2.5 2.5 0 0 0-.001 5.5V27A3 3 0 0 0 3 30h2c0 1.657 1.342 3 2.999 3h22A3 3 0 0 0 33 30V2.5A2.5 2.5 0 0 0 30.5 0zM28 26.586V6.414l3-3v26.172l-3-3zM6.999 3A1 1 0 0 1 8 2h21.586l-3 3H7.999a1 1 0 0 1-1-1V3zM5.183 28H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h2.183a2.993 2.993 0 0 0 2.816 2H26v19H7.999a2.99 2.99 0 0 0-2.816 2zm1.816 2v-1A1 1 0 0 1 8 28h18.586l3 3H7.999a1 1 0 0 1-1-1z"
      />
    </svg>
  ),
  'bus-arrow-out': (size, color) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 42 20"
      width={size}
      height={size}
    >
      <path
        fillRule="evenodd"
        fill={color}
        d="M41.999 10L38 13v-2h-4.201c-.399 1.3-1.699 2.1-3.099 2-1.501-.1-2.701-1.4-2.701-2.9 0-1.7 1.301-3 3.001-3 1.3 0 2.4.8 2.799 1.9H38V7l3.999 3zM17 19.5c0 .3-.2.5-.5.5h-3c-.3 0-.501-.2-.501-.5V18H5v1.5c0 .3-.201.5-.5.5h-3c-.301 0-.5-.2-.5-.5v-1.8c-.6-.3-1-1-1-1.7V9l.9-6c.1-.8.5-1.4 1.2-1.8C3.2.7 5.3 0 9 0s5.8.7 6.9 1.3c.6.3 1.1 1 1.2 1.7l.9 6v7c0 .7-.401 1.4-1 1.7v1.8zM3.5 15c.8 0 1.5-.7 1.5-1.5S4.3 12 3.5 12 2 12.7 2 13.5 2.7 15 3.5 15zm12-11.1c-.1-.5-.4-.9-.8-1.1-.8-.4-2.2-.9-5.7-.9s-4.9.4-5.6.8c-.5.2-.7.6-.8 1.1L2 8h14l-.5-4.1zm-1 8.1c-.8 0-1.501.7-1.501 1.5S13.7 15 14.5 15c.799 0 1.5-.7 1.5-1.5s-.701-1.5-1.5-1.5z"
      />
    </svg>
  ),
  checkedStep: (size, color) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 10"
      width="12"
      height="10"
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M4.228 9.928L-.003 5.821l1.396-1.448 2.835 2.753L10.597.943l1.394 1.448-7.763 7.537z"
      />
    </svg>
  ),
  'bus-arrow-in': (size, color) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 42 20"
      width={size}
      height={size}
    >
      <path
        fillRule="evenodd"
        fill={color}
        d="M39 12.9c-1.3 0-2.4-.8-2.801-1.9H32v2l-4.001-3L32 7v2h4.199C36.6 7.7 37.9 6.9 39.3 7c1.499.1 2.699 1.4 2.699 2.9 0 1.7-1.3 3-2.999 3zm-22 6.6c0 .3-.2.5-.5.5h-3c-.3 0-.501-.2-.501-.5V18H5v1.5c0 .3-.201.5-.5.5h-3c-.301 0-.5-.2-.5-.5v-1.8c-.6-.3-1-1-1-1.7V9l.9-6c.1-.8.5-1.4 1.2-1.8C3.2.7 5.3 0 9 0s5.8.7 6.9 1.3c.6.3 1.1 1 1.2 1.7l.9 6v7c0 .7-.401 1.4-1 1.7v1.8zM3.5 15c.8 0 1.5-.7 1.5-1.5S4.3 12 3.5 12 2 12.7 2 13.5 2.7 15 3.5 15zm12-11.1c-.1-.5-.4-.9-.8-1.1-.8-.4-2.2-.9-5.7-.9s-4.9.4-5.6.8c-.5.2-.7.6-.8 1.1L2 8h14l-.5-4.1zm-1 8.1c-.8 0-1.501.7-1.501 1.5S13.7 15 14.5 15c.799 0 1.5-.7 1.5-1.5s-.701-1.5-1.5-1.5z"
      />
    </svg>
  ),
  'chevron-left': (size, color) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 9 12"
      width={size}
      height={size}
    >
      <path
        fillRule="evenodd"
        fill={color}
        d="M7.613 12.002L-.011 5.999 7.613-.004l1.376 1.49-5.732 4.513 5.732 4.512-1.376 1.491z"
      />
    </svg>
  ),
  bus: (size, color) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 20"
      width={size}
      height={size}
    >
      <path
        fillRule="evenodd"
        fill={color}
        d="M9 0C5.3 0 3.2.7 2.1 1.2 1.4 1.6 1 2.2.9 3L0 9v7c0 .7.4 1.4 1 1.7v1.8c0 .3.199.5.5.5h3c.299 0 .5-.2.5-.5V18h7.999v1.5c0 .3.201.5.501.5h3c.3 0 .5-.2.5-.5v-1.8c.599-.3 1-1 1-1.7V9l-.9-6c-.1-.7-.6-1.4-1.2-1.7C14.8.7 12.7 0 9 0zm0 1.9c3.5 0 4.9.5 5.7.9.4.2.7.6.8 1.1L16 8H2l.6-4.2c.1-.5.3-.9.8-1.1.7-.4 2.1-.8 5.6-.8zM3.5 12c.8 0 1.5.7 1.5 1.5S4.3 15 3.5 15 2 14.3 2 13.5 2.7 12 3.5 12zm11 0c.799 0 1.5.7 1.5 1.5s-.701 1.5-1.5 1.5c-.8 0-1.501-.7-1.501-1.5S13.7 12 14.5 12z"
      />
    </svg>
  ),
  remove: (size, color) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width={size}
      height={size}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M15.997 14.543l-1.454 1.454L8 9.454l-6.543 6.543-1.454-1.454L6.546 8 .003 1.457 1.457.003 8 6.546 14.543.003l1.454 1.454L9.454 8l6.543 6.543z"
      />
    </svg>
  ),
  'direction-arrow': (size, color) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 10"
      width={size}
      height={size}
    >
      <path
        fillRule="evenodd"
        fill={color}
        d="M5.142.17C2.228.17-.001 2.339-.001 5.175c0 2.503 2.058 4.672 4.629 4.839 2.4.167 4.629-1.168 5.314-3.337h7.2v3.337l6.857-5.005L17.142.003V3.34h-7.2C9.257 1.505 7.371.17 5.142.17z"
      />{' '}
    </svg>
  ),
  ticket: (size, color) => (
    <svg viewBox="0 0 16 16" width={size} height={size}>
      <path
        fill={color}
        fillRule="evenodd"
        d="M12.932 9.225L6.78 3.072 9.848.004l1.343 1.344c-.46.969-.3 2.16.503 2.963a2.603 2.603 0 0 0 2.963.502L16 6.156l-3.068 3.069zm-.707.707L6.157 16l-1.344-1.343c.461-.97.3-2.161-.502-2.963a2.602 2.602 0 0 0-2.963-.502L.004 9.848 6.072 3.78l6.153 6.152z"
      />
    </svg>
  ),
  seatings: (size, color) => (
    <svg width={size} height={size} viewBox="0 0 14 16">
      <path
        fill={color}
        fillRule="evenodd"
        d="M13.267 15.758c-.608.36-1.315.272-1.578-.195l-1.443-2.564H6.308c-.725 0-1.312-.447-1.312-1 0-.171.07-.324.17-.465l-1.132-4.61c-.2-.816.243-1.655.991-1.874.748-.218 1.516.266 1.716 1.082l1.195 4.867h2.747c.164 0 .317.03.462.071.484-.125.953.002 1.157.364l1.589 2.824c.264.468-.016 1.139-.624 1.5zM5 4a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm3 10a1 1 0 0 1 0 2H3l-.004-.001a.755.755 0 0 1-.115-.023A.99.99 0 0 1 2 15c0-.102.03-.196.058-.289L.042 6.301c-.132-.549.16-1.113.651-1.26.491-.147.996.179 1.128.728L3.794 14H8z"
      />
    </svg>
  ),
  arrowToSides: (size, color) => (
    <svg viewBox="0 0 24 24" width={size} height={size}>
      <polygon
        fill={color}
        points="24,12 17.1,7 17.1,10.3 12.5,10.3 11.5,10.3 6.8,10.3 6.8,7 0,12 6.8,17 6.8,13.7 11.5,13.7 12.5,13.7 
      17.1,13.7 17.1,17 "
      />
    </svg>
  ),
};



// WEBPACK FOOTER //
// ./src/components/Icon/icons.js